import { Transition } from "@uirouter/react";
import { MenuNode, MenuRoute } from "../../components/menu";
import { LaunchConfigurationsDTO } from "../../store/launch-configurations/models/dto";
import { LaunchConfigurationsService } from "../../store/launch-configurations/service";
import { LeafRole } from "../../utils/and-or-tree";
import { ShellRouteNames } from "../shell/route-names";

import { LaunchConfigurationsComponent } from "./all";
import { NewConfigurationLaunchPage } from "./new";

const names = {
  all: `${ShellRouteNames.shell}.launch-configuration-all`,
  single: `${ShellRouteNames.shell}.launch-configuration-single`,
  new: `${ShellRouteNames.shell}.launch-configuration-new`,
};

const states: MenuRoute[] = [
  {
    name: names.new,
    url: "/launch-configurations/new",
    component: NewConfigurationLaunchPage,
    data: {
      title: "individual-onboarding-setup",
    },
  },
  {
    name: names.single,
    component: NewConfigurationLaunchPage,
    url: "/launch-configurations/:id",
    data: {
      title: "single-configuration",
    },
    params: {
      id: {
        type: "string",
      },
    },
    resolve: [
      {
        token: "id",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) => trans.params().id,
      },
      {
        token: "item",
        deps: ["id"],
        resolveFn: (id: string) =>
          LaunchConfigurationsService.getLaunchConfiguration(id).catch(
            (err) => err
          ),
      },
    ],
    redirectTo: (trans: Transition) => {
      // getAsync tells the resolve to load
      let resolvePromise: Promise<
        LaunchConfigurationsDTO.Responses.GetSingle.T | Error
      > = trans.injector().getAsync("item");
      return resolvePromise.then((
        err // TODO: maybe redirect to 404
      ) => (err instanceof Error ? names.all : undefined));
    },
  },
  {
    name: names.all,
    component: LaunchConfigurationsComponent,
    url: "/launch-configurations/",
    data: {
      title: "view-all-individual-setups",
    },
  },
];

export const sidebar: MenuNode.MenuNode = {
  icon: "rocket",
  title: "launch-configurations",
  children: [
    {
      icon: "rocket",
      route: states[0],
    },
    {
      icon: "rocket",
      route: states[2],
    },
  ],
  roles: new LeafRole("ROLE_MERCHANT"),
};

export const LaunchConfigurationsRoutes = {
  names,
  states,
  sidebar,
};
